<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editPackage") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #267d26">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Color Input -->
          <label
            for="color"
            class="text-center"
            style="color: #267d26; font-size: 16px"
            >{{ $t("PLACEHOLDERS.color") }}
            <span class="text-danger">*</span></label
          >
          <div class="d-flex justify-space-around">
            <v-color-picker class="ma-2" v-model="data.color"></v-color-picker>
          </div>
          <!-- End:: Color Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Number of Available Auctions -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.number_of_available_bids')"
            v-model.number="data.number_of_available_bids"
            min="1"
            required
          />
          <!-- End:: Number of Available Auctions -->

          <!-- Start:: Number of Available Bids -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.number_of_available_auctions')"
            v-model.number="data.number_of_available_auctions"
            min="1"
            required
          />
          <!-- End:: Number of Available Bids -->
          <!-- Start:: Price Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.price')"
            v-model.number="data.price"
            min="1"
            required
          />
          <!-- End:: Price Input -->

          <!-- Start:: Price After Discount Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.price_after_discount')"
            v-model.number="data.price_after_discount"
            min="0"
          />
          <!-- End:: Price After Discount Input -->

          <!-- Start:: Auction Order -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.auction_order')"
            v-model.number="data.auction_order"
            min="1"
            :required="!data.number_of_subscribes > 0"
            :disabled="data.number_of_subscribes > 0"
            class="mb-0"
          />
          <p
            v-if="data.number_of_subscribes > 0"
            class="mb-5 mx-3"
            style="color: #267d26"
          >
            {{ $t("PLACEHOLDERS.package_has_subscriptions") }}
          </p>
          <!-- End:: Auction Order -->

          <!-- Start:: Deactivate Switch Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "EditPackage",
  data() {
    return {
      isWaitingRequest: false,
      data: {
        color: null,
        name_ar: "",
        name_en: "",
        number_of_available_auctions: null,
        number_of_available_bids: null,
        auction_order: null,
        number_of_subscribes: null,
        price: null,
        price_after_discount: null,
        active: null,
      },
      statusOptions: [
        { id: 1, name: this.$t("STATUS.active"), value: 1 },
        { id: 0, name: this.$t("STATUS.notActive"), value: 0 },
      ],
    };
  },
  methods: {
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("_method", "put");
      REQUEST_DATA.append("color", this.data.color);
      REQUEST_DATA.append("name[ar]", this.data.name_ar);
      REQUEST_DATA.append("name[en]", this.data.name_en);
      REQUEST_DATA.append(
        "number_of_available_auctions",
        this.data.number_of_available_bids
      );
      REQUEST_DATA.append(
        "number_of_available_bids",
        this.data.number_of_available_auctions
      );
      REQUEST_DATA.append("auction_order", this.data.auction_order);
      REQUEST_DATA.append("price", this.data.price);
      REQUEST_DATA.append(
        "price_after_discount",
        this.data.price_after_discount
      );
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      try {
        await this.$axios({
          method: "POST",
          url: `packages/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/packages/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
    // start show data
    async showPackage() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `packages/${this.$route.params?.id}`,
        });
        this.data.color = res.data.data.data.color;
        this.data.name_ar = res.data.data.data.name_ar;
        this.data.name_en = res.data.data.data.name_en;
        this.data.number_of_available_auctions =
          res.data.data.data.number_of_available_bids;
        this.data.number_of_available_bids =
          res.data.data.data.number_of_available_auctions;
        this.data.auction_order = res.data.data.data.auction_order;
        this.data.number_of_subscribes =
          res.data.data.data.number_of_subscribes;
        this.data.price = res.data.data.data.price;
        this.data.price_after_discount =
          res.data.data.data.price_after_discount;
        this.data.active = res.data.data.data.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },
  created() {
    this.showPackage();
  },
};
</script>
